import React from 'react';
import { Settings } from 'react-slick';

import { v4 } from 'uuid';

import { AxiosResponse } from 'axios';

import { httpModules } from '@app/helpers/http.module';
import { Carousel } from '@app/components/Carousel/Carousel';
import { DestinationURL } from '@app/constants/url.constants';
import { Button, ButtonVariant, ActionMode } from '@app/components/Button/Button';

export interface FeaturedDestination {
	clientId: string;
	destinationId: string;
	bookingId: number;
	product: string;
	pid: number;
	imgName: string;
	callToAction: string;
}

function getButtonText(product: string) {
	if (product === 'Transatlantic') return 'Explore Transatlantic Crossings';
	if (product === 'Australia/New Zealand') return 'Explore Australia & New Zealand';

	return `Explore ${product}`;
}

interface DestinationCardProps {
	value: FeaturedDestination;
	ref: React.RefObject<HTMLDivElement>;
}

const DestinationCard: React.FC<DestinationCardProps> = (props: DestinationCardProps) => {
	return (
		<div ref={props.ref}>
			<img
				alt=""
				src={props.value.imgName}
			/>
			<Button
				style={{
					margin: '2rem auto 0 auto',
					display: 'block',
				}}
				variant={ButtonVariant.Filled}
				link={`${DestinationURL}${props.value.destinationId}&type=0,1&order.direction=1&order.tag=Price&page=1`}
				action={ActionMode.InternalLink}
			>
				{props.value.callToAction}
			</Button>
		</div>
	);
};

const settings: Settings = {
	dots: false,
	centerPadding: '0',
	infinite: true,
	speed: 500,
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	className: 'slider',
	responsive: [
		{

			breakpoint: 1024,
			settings: {
				centerPadding: '0',
				infinite: true,
				slidesToScroll: 1,
				className: 'slider',
				slidesToShow: 1,
			},
		},
		{
			breakpoint: 576,
			settings: {
				centerPadding: '0',
				infinite: true,
				slidesToScroll: 1,
				className: 'slider',
				slidesToShow: 1,
			},
		},

	],
};

export const FeaturedDestination: React.FC = () => {
	const [items, setItems] = React.useState<Array<FeaturedDestination>>([]);
	React.useEffect(() => {
		httpModules
			.get<Array<FeaturedDestination>>('/api/pages/v1/FeaturedDestination')
			.then((response: AxiosResponse<Array<FeaturedDestination> | undefined>) => {
				const list = response.data ?? [];
				list.forEach((item: FeaturedDestination) => {
					item.clientId = v4();
					item.imgName = `/images/vipExclusives/destinations/${item.imgName}`;
					item.callToAction = getButtonText(item.product);
				});
				setItems(response.data ?? []);
			})
			.catch((error) => {
				console.log(error);
			});
	}, []);
	const widthCardRef = React.useRef<HTMLDivElement>(null);

	return (
		<div className="carousel-container">
			<div className="carousel-container__center featuredDestination">
				<div className="col-12 col-xs-7 col-sm-5">
					<div className="carousel-container__title-block text-size_hard-large layout-container dense content-valign_center">
						<div className="carousel-container__title font-family_primary condensed font-weight_semi-bold">
							<div className="text-uppercase">
								Featured
							</div>
							<div className="font-family_decorative font-weight_regular">
								Destinations
							</div>
						</div>
					</div>
				</div>

				<Carousel
					className="deals-carousel col-12"
					total={items.length}
					settings={settings}
					cardRef={widthCardRef}
				>
					{
						items.map((item) => <DestinationCard key={item.clientId} value={item} ref={widthCardRef} />)
					}
				</Carousel>
			</div>
			<div className="carousel-container__right col-xl-7" />
		</div>
	);
};
